import React from "react";

const SectionTitle = (props) => {
  const { sectionTitleText } = props;
  return (
    <div className="row d-flex justify-content-center">
      <div className="menu-content col-lg-8">
        <div className="title text-center">
          <h1 className="mb-10">{sectionTitleText}</h1>
          <p />
        </div>
      </div>
    </div>
  );
};

export default SectionTitle;
